"use client";
import AnimatedText from "@/components/common/AnimatedText";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function Cta() {
  const [banner, setBanner] = useState("");

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await fetch("/api/banners");
        const data = await response.json();
        setBanner(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchBanner();
  }, []);

  return (
    <section className="cta-banner-section section-padding pb-0 pt-0">
      <div className="container-fluid px-0">
        <div
          className="cta-banner-wrapper fix bg-cover"
          style={{
            backgroundImage: `url(${banner?.banner?.contactusbanner})`,
          }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div>
                  <h2 className="splt-txt wow">
                    <AnimatedText text="Excited to Visit? Connect" /> <br />
                    <AnimatedText text="With Our Team!" />{" "}
                  </h2>
                  <Link
                    href={`/contact`}
                    className="theme-btn bg-white wow fadeInUp"
                    data-wow-delay=".6s"
                  >
                    contact us
                    <i className="fa-regular fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
